import { getAuthenticationHeaders } from '../../../common/utils/auth-utils';
import { getDeleteWishlistsUrlMagento } from '../../../common/constants/shop-api';
import { getResponseData } from '../../../common/utils/api-utils';

export async function deleteWishListApiCallMagento(wishListId: number): Promise<any> {
  const url = getDeleteWishlistsUrlMagento(wishListId);

  return await getResponseData(
    new Request(url, {
      method: 'DELETE',
      credentials: 'include',
      headers: getAuthenticationHeaders()
    })
  );
}
